import { Container, Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Menu } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Logo from "../../styles/img/lolc-logo.png";
import PinnacleLogo from "../../styles/img/pinnacleLogo.png";
import SalaryPlusLogo from "../../styles/img/salarypluslogo.png";
import SalaryPartnerLogo from "../../styles/img/salarypartner.png";
import PrestigeAccountLogo from "../../styles/img/prestigeacclogo.png";
import StandardAccountLogo from "../../styles/img/df-logo.png";
import { EnvelopeIcon } from "../../styles/img/svg/EnvelopeIcon";
import { BellIcon } from "../../styles/img/svg/BellIcon";
import { ArrowDownIcon } from "../../styles/img/svg/ArrowDownIcon";
import { ProfileIocn } from "../../styles/img/svg/ProfileIocn";
import { MenuIcon } from "../../styles/img/svg/MenuIcon";
import { DashboardLanguageSelect } from "./common/DashboardLanguageSelect";
import { ProfileDropdownIcon } from "../../styles/img/svg/ProfileDropdownIcon";
import { LogoutIcon } from "../../styles/img/svg/LogoutIcon";
import { logoutAuthRequest } from "../../_redux/_actions/auth.actions";
import { UiMobileSideMenu } from "./UiMobileSideMenu";
import {
  getProfileDetailsRequest,
  notificationDetailClear,
  notificationListClear,
  notificationUnreadCountRequest,
  setCommonHasChangeForm,
} from "../../_redux/_actions";
import { dashboardSecureMailNotificationRequest } from "../../_redux/_actions/dashboard.actions";
import {
  commonConstants,
  TRANSLATION_CONST,
  notificationConstants,
  authConstants,
} from "../../_redux/_constants";
import { UiPopup } from "./common/UiModal";
import { LeaveConfirmationPopup } from "./Popups/ConfirmationPopup";
import { ConfirmationIcon } from "../../styles/img/svg/ConfirmationIcon";
import { UiNotifications } from "./Dashboard/Notifications/UiNotifications";

export const UiNavBar = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { profileDataState } = useSelector((state) => ({
    profileDataState: state?.profile?.profileData,
  }));

  const divRef = useRef(null);
  const notificationRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const commonData = useSelector((state) => state?.commonData);
  const checkForm = useSelector((state) => state.checkForm);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [profilePageEnable, setProfilePageEnable] = useState(false);

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [showLeaveFormModal, setShowLeaveFormModal] = useState(false);

  const toggleProfileDropdown = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  const goToProfile = () => {
    dispatch(getProfileDetailsRequest());
    setProfilePageEnable(true);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setShowProfileDropdown(false);
    }

    // comments because of issue with notification privous bug fix
    // if (
    //   notificationRef.current &&
    //   !notificationRef.current.contains(event.target)
    // ) {
    //   setShowNotification(false);
    // }
  };

  const logout = () => {
    setShowLogoutModal(true);
  };
  const [showLanguageSelect, setShowLanguageSelect] = useState(false);

  const [showNotification, setShowNotification] = useState(false);
  const handleBellClick = () => {
    dispatch(notificationListClear());
    dispatch(notificationDetailClear());
    dispatch(notificationUnreadCountRequest({ locale: i18n.language }));
    setShowNotification((prev) => !prev);
  };
  let unreadCount = useSelector(
    (state) => state?.notification?.unReadNotificationCount || 0,
  );

  let unreadMailCount = useSelector(
    (state) => state?.notification?.unReadSecureMailCount || 0,
  );

  const [displayCount, setDisplayCount] = useState("");
  const [displaySecureMailCount, setDisplaySecureMailCount] = useState("");

  useEffect(() => {
    //if the unread count is over 9, it should be displayed as "9+"
    if (unreadCount > notificationConstants.NOTIFICATION_MAX_COUNT) {
      setDisplayCount(notificationConstants.NOTIFICATION_UNREAD_COUNT_EXCEED);
    } else {
      setDisplayCount(unreadCount);
    }
  }, [unreadCount]);

  useEffect(() => {
    //if the unread count is over 9, it should be displayed as "9+"
    if (unreadMailCount > notificationConstants.NOTIFICATION_MAX_COUNT) {
      setDisplaySecureMailCount(
        notificationConstants.NOTIFICATION_UNREAD_COUNT_EXCEED,
      );
    } else {
      setDisplaySecureMailCount(unreadMailCount);
    }
  }, [unreadMailCount]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Refresh notification unread count on initial load and whenever route changes
  useEffect(() => {
    dispatch(notificationUnreadCountRequest({ locale: i18n.language }));
  }, [location.pathname, i18n.language]);

  // Detect page reload using sessionStorage
  useEffect(() => {
    const isReload = sessionStorage.getItem(authConstants.IS_PAGE_ACTIVE);
    if (isReload) {
      sessionStorage.removeItem(authConstants.IS_PAGE_ACTIVE);
      dispatch(logoutAuthRequest());
    }

    const handleBeforeUnload = () => {
      sessionStorage.setItem(authConstants.IS_PAGE_ACTIVE, "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [dispatch]);

  useEffect(() => {
    if (profileDataState?.customer?.nickname && profilePageEnable) {
      navigate("/app/profile");
    }
  }, [profileDataState]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (profileDataState?.customer?.nickname && profilePageEnable) {
      navigate("/app/profile");
    }
  }, [profileDataState]);

  const getLogoByAccountType = (type) => {
    switch (type) {
      case commonConstants.CUSTOMER_TIER_PINNACLE_TYPE:
        return PinnacleLogo;
      case commonConstants.CUSTOMER_TIER_SALARY_PARTNER_TYPE:
        return SalaryPartnerLogo;
      case commonConstants.CUSTOMER_TIER_SALARY_PLUS_TYPE:
        return SalaryPlusLogo;
      case commonConstants.CUSTOMER_TIER_PRESTIGE_TYPE:
        return PrestigeAccountLogo;
      default:
        return StandardAccountLogo;
    }
  };

  const handleCloseLogoutModal = () => {
    setShowLogoutModal(false);
  };

  const handleLogoutConfirm = () => {
    setShowLogoutModal(false);
    dispatch(logoutAuthRequest());
  };
  const selectedLogo = getLogoByAccountType(commonData?.customerTier);

  const closeForm = () => {
    dispatch(notificationUnreadCountRequest({ locale: i18n.language }));
    navigate("/app/dashboard");
  };

  const checkFormChanges = () => {
    if (checkForm?.hasFormChanged) {
      setShowLeaveFormModal(true);
    } else {
      closeForm();
    }
  };

  const handleClickLeaveSubmit = () => {
    setShowLeaveFormModal(false);
    dispatch(setCommonHasChangeForm(false));
    closeForm();
  };

  const handleCloseLeaveModel = () => {
    setShowLeaveFormModal(false);
  };

  useEffect(() => {
    if (window.location.pathname === "/app/dashboard") {
      setShowLanguageSelect(true);
    } else {
      setShowLanguageSelect(false);
    }
  }, [window.location.pathname]);

  const truncateText = (text, maxLength = 15) =>
    text?.length > maxLength ? text.substring(0, maxLength) + "..." : text;

  return (
    <>
      <div className="df-top-navbar">
        <Container maxWidth="xxl">
          <Grid container spacing={2} className="df-align-center">
            <Grid size={2}>
              <div className="df-top-navbar__left-logo">
                <button
                  className="df-mobile-toggle-btn"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <Menu />
                </button>

                <img src={Logo} onClick={() => checkFormChanges()} />

                <h3>
                  {t("Hi")} {truncateText(commonData?.nickName, 15)}!
                </h3>
                {/* <div
                  className={`df-top-navbar__center ${
                    commonData?.nickName?.length >= 15
                      ? "df-top-navbar__center--long-name"
                      : ""
                  }`}
                >
                  <img src={selectedLogo} />
                </div> */}
              </div>
            </Grid>

            <Grid size={7}>
              {/* <div className="df-top-navbar__center">
                <img src={selectedLogo} />
              </div> */}
            </Grid>
            <Grid size={3}>
              <div className="df-top-navbar__right">
                <div
                  className="df-nav-notif-wrpper"
                  onClick={() => {
                    dispatch(
                      notificationUnreadCountRequest({ locale: i18n.language }),
                    );
                    navigate("/app/secure-mail");
                  }}
                >
                  <EnvelopeIcon />
                  {unreadMailCount !== 0 && (
                    <span className="df-nav-notif-wrpper__count">
                      {displaySecureMailCount}
                    </span>
                  )}
                </div>

                <div className="df-nav-notif-wrpper" ref={notificationRef}>
                  <div onClick={handleBellClick}>
                    <BellIcon />
                    {unreadCount !== 0 && (
                      <span className="df-nav-notif-wrpper__count">
                        {displayCount}
                      </span>
                    )}
                  </div>
                  {showNotification && (
                    <UiNotifications
                      setShowNotification={setShowNotification}
                    />
                  )}
                </div>

                {/* Not in LOLC  */}
                {/* {showLanguageSelect && <DashboardLanguageSelect />} */}

                <div className="df-nav-prof-dropdown ">
                  <div
                    className="df-nav-prof-dropdown__profile-icon"
                    onClick={toggleProfileDropdown}
                  >
                    {commonData?.profilePicturePath ? (
                      <img
                        src={commonData?.profilePicturePath}
                        alt="Profile"
                        className="df-profile-picture"
                      />
                    ) : (
                      <ProfileIocn />
                    )}
                  </div>
                  <div
                    className="df-nav-prof-dropdown__menu-icon"
                    onClick={toggleProfileDropdown}
                  >
                    <MenuIcon />
                  </div>

                  {showProfileDropdown && (
                    <div className="df-profile-dropdown" ref={divRef}>
                      <div
                        className="df-profile-dropdown__item"
                        onClick={goToProfile}
                      >
                        <ProfileDropdownIcon />
                        <span
                          className={
                            i18n.language === TRANSLATION_CONST?.SINHALA.lan &&
                            "df-pdi-sinh"
                          }
                        >
                          {t("Profile")}
                        </span>
                      </div>

                      <div
                        className="df-profile-dropdown__item"
                        onClick={logout}
                      >
                        <LogoutIcon />
                        <span
                          className={
                            i18n.language === TRANSLATION_CONST?.SINHALA.lan &&
                            "df-pdi-sinh"
                          }
                        >
                          {t("Log Out")}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <UiPopup openModal={showLogoutModal} handleClose={handleCloseLogoutModal}>
        <LeaveConfirmationPopup
          icon={<ConfirmationIcon />}
          message=""
          successBtnText={t("Yes")}
          buttonOnClickClose={handleCloseLogoutModal}
          buttonOnClick={handleLogoutConfirm}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>{t("Are you sure you want to log out?")}</p>
        </LeaveConfirmationPopup>
      </UiPopup>

      <UiPopup
        openModal={showLeaveFormModal}
        handleClose={handleCloseLeaveModel}
      >
        <LeaveConfirmationPopup
          icon={<ConfirmationIcon />}
          message={t("Leaving this page?")}
          buttonOnClickClose={handleCloseLeaveModel}
          buttonOnClick={handleClickLeaveSubmit}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>
            {t(
              "Are you sure you want to leave this page? You have some unsaved changes.",
            )}
          </p>
        </LeaveConfirmationPopup>
      </UiPopup>

      <UiMobileSideMenu
        nickName={truncateText(commonData?.nickName, 15)}
        selectedLogo={selectedLogo}
        handleToggle={handleToggle}
        openMenu={isOpen}
        closeMobileMenu={() => setIsOpen(false)}
        goToProfile={goToProfile}
      />
    </>
  );
};
